
export const AppVersion = "0.0.1-local";
